class VideoReviews extends HTMLElement {
    constructor() {
        super();
        this.init();
    }

    init() {
        const initFn = () => {
            if (typeof window.Swiper !== 'undefined') {
                this.initSwiper();
                this.initVideoControls();
            } else {
                setTimeout(initFn, 100);
            }
        };
        initFn();
    }

    initSwiper() {
        const container = this.querySelector('.swiper');
        if (!container) return;

        const safari = document.documentElement.classList.contains('safari');

        this.swiper = new Swiper(container, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            loop: false,
            observer: !safari,
            observeParents: !safari,
            breakpoints: {
                750: {
                    spaceBetween: 20
                }
            }
        });
    }

    initVideoControls() {
        const cards = this.querySelectorAll('.video-review-card__media');
        let currentPlaying = null;

        cards.forEach(card => {
            const video = card.querySelector('video');
            const playBtn = card.querySelector('.video-review-card__play');
            const muteBtn = card.querySelector('.video-review-card__mute');

            if (!video) return;

            const updateMuteIcon = () => {
                if (!muteBtn) return;
                if (video.muted) {
                    muteBtn.querySelector('.icon-volume-on').style.display = 'none';
                    muteBtn.querySelector('.icon-volume-off').style.display = 'block';
                } else {
                    muteBtn.querySelector('.icon-volume-on').style.display = 'block';
                    muteBtn.querySelector('.icon-volume-off').style.display = 'none';
                }
            };

            const togglePlay = () => {
                if (video.paused) {
                    // Pause currently playing if exists
                    if (currentPlaying && currentPlaying !== video) {
                        currentPlaying.pause();
                        const prevCard = currentPlaying.closest('.video-review-card__media');
                        if (prevCard) {
                            prevCard.classList.remove('is-playing');
                            const prevMuteBtn = prevCard.querySelector('.video-review-card__mute');
                            if (prevMuteBtn) prevMuteBtn.style.display = 'none';
                        }
                    }
                    video.play().catch(e => console.warn('Video failed to play:', e));
                    card.classList.add('is-playing');
                    if (muteBtn) {
                        muteBtn.style.display = 'flex';
                        updateMuteIcon();
                    }
                    currentPlaying = video;
                } else {
                    video.pause();
                    card.classList.remove('is-playing');
                    if (muteBtn) muteBtn.style.display = 'none';
                }
            };

            card.addEventListener('click', togglePlay);

            // Mute Toggle (catch event so it doesn't pause video)
            if (muteBtn) {
                muteBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    video.muted = !video.muted;
                    updateMuteIcon();
                });
            }

            video.addEventListener('ended', () => {
                card.classList.remove('is-playing');
                if (muteBtn) muteBtn.style.display = 'none';
            });
        });
    }
}

if (!customElements.get('video-reviews')) {
    customElements.define('video-reviews', VideoReviews);
}
